import { IncomingMessage } from 'http';

import { cookies } from 'next/headers';

import { fechFromBPartsApi } from './utils';

type StocksArray = Array<{
  category_identifier?: string;
  part_identifier?: string;
  car_identifier?: string;
}>;

type StocksOptions = {
  no_round: boolean;
  stocks: StocksArray;
};

export const fetchStocks = async (
  {
    locale,
    options,
  }: {
    locale: string;
    options: StocksOptions;
  },
  req?: IncomingMessage
) => {
  const result = await fechFromBPartsApi(
    `/${locale}/shop/stocks`,
    {
      method: 'post',
      headers: new Headers({
        ...(!!req ? (req?.headers as HeadersInit) : {}),
        'Content-Type': 'application/json',
        //cookie: '',
        'X-CSRFToken': req?.cookies?.csrftoken || '',
      } as HeadersInit),

      credentials: 'include',

      body: JSON.stringify(options),
    },
    { enableCustomErrorWrapper: true }
  );
  
  return result;
};

export const fetchStocksForCategories = async (
  {
    locale,
    categories,
    vehicle,
    csrftoken,
  }: {
    locale: string;
    categories: Array<string>;
    vehicle?: string;
    csrftoken: string;
  },
  req?: IncomingMessage
) => {
  const stocks: StocksArray = categories.map((c) => ({
    category_identifier: c,
    ...(vehicle ? { car_identifier: vehicle } : {}),
  }));

  const options: StocksOptions = { no_round: true, stocks };

  const mi = await fetchStocks({ locale, options }, req);
  return mi;
};

export const fetchStocksForVehicles = async (
  {
    locale,
    category,
    part,
    vehicles,
  }: {
    locale: string;
    category?: string;
    part?: string;
    vehicles: Array<string>;
  },
  req?: IncomingMessage
) => {
  const stocks: StocksArray = vehicles.map((v) => ({
    car_identifier: v,
    ...(category ? { category_identifier: category } : {}),
    ...(part ? { part_identifier: part } : {}),
  }));

  const options: StocksOptions = { no_round: false, stocks };

  return await fetchStocks({ locale, options, csrftoken }, req);
};
